import { z, zCoercedBoolean } from '@harvestiq/zod';
import {
  CampaignCoverageTier,
  RmaLrpCommodityCodes,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { zCalendarDate, zDecimalRequired, zIsoDate } from '@harvestiq/zod';

export const emailLrpQuoteRequestSchema = z.object({
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
  numberOfHead: z.coerce.number(),
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate().optional(),
  endDate: zIsoDate().optional(),
  targetWeight: zDecimalRequired(),
  coverageTier: z.nativeEnum(CampaignCoverageTier).optional(),
  recipients: z.string().email().array().min(1), // At least one recipient is required
  message: z.string().optional(),
  allowExternalRecipients: z.boolean().optional(),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
});

export type EmailLrpQuoteRequest = z.input<typeof emailLrpQuoteRequestSchema>;

export const emailLrpQuoteResponseSchema = z
  .object({
    sent: z.number(),
    data: z
      .object({
        filename: z.string(),
        fileUrl: z.string().url(),
      })
      .array(),
  })
  .or(
    z.object({
      errors: z
        .object({
          message: z.string(),
        })
        .array(),
    })
  );

export type EmailLrpQuoteResponse = z.infer<typeof emailLrpQuoteResponseSchema>;
